import React from 'react';

export const ROW_TYPE = {
  MC: 0,
  DISTRICT: 1,
  ROUTE: 2
};

const ReportRow = (props) => {
  const {
    branchCode,
    districtCode,
    routeNumber,
    totalProposed,
    totalCompleted,
    totalWithinMad,
    totalCsrProposed,
    totalCsrCompleted,
    totalCsrWithinMad,
    totalDmProposed,
    totalDmCompleted,
    totalDmWithinMad,
    totalOtherProposed,
    totalOtherCompleted,
    totalOtherWithinMad,
    expand,
    rowType,
    onClick
  } = props;

  return (
    <tr
      key={`${districtCode}-row`}
      onClick={!!onClick ? () => onClick(!expand) : null}
      className="mc-report-data-row"
    >
      <td>
        {rowType === ROW_TYPE.MC ? (expand ? '-  ' : '+  ') + branchCode : ''}
      </td>
      <td>
        {rowType !== ROW_TYPE.ROUTE
          ? (districtCode !== '*' ? (expand ? '-  ' : '+  ') : '') +
            districtCode
          : ''}
      </td>
      <td>{routeNumber}</td>
      <td>{totalProposed}</td>
      <td>{totalCompleted}</td>
      <td>{totalWithinMad}</td>
      <td>{totalDmProposed}</td>
      <td>{totalDmCompleted}</td>
      <td>{totalDmWithinMad}</td>
      <td>{totalCsrProposed}</td>
      <td>{totalCsrCompleted}</td>
      <td>{totalCsrWithinMad}</td>
      <td>{totalOtherProposed}</td>
      <td>{totalOtherCompleted}</td>
      <td>{totalOtherWithinMad}</td>
    </tr>
  );
};

export default ReportRow;
